var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('v-flex',{staticClass:"mt-5"},[_c('Avatar',{attrs:{"username":`${_vm.nombrePerfil}`,"size":50,"rounded":true,"color":"#fff"}})],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }